module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerHeadshots/nba/survive-3d01d509a2b642ddd413fb0077238b6a.svg";